import Model, { executeMutation, GqlError, ID, Integer, JsonObject, MODEL_LEVEL } from 'src/models/model'
import Archivable from 'src/models/model/concerns/Archivable'
import Librariable from 'src/models/model/concerns/Librariable'
import SalesChannelRestrictable, { MENU_DEFAULT as SALES_CHANNEL_MENU_DEFAULT } from 'src/models/model/concerns/SalesChannelRestrictable'
import Modifier from 'src/models/modifier-set/Modifier'

export default class ModifierSet extends Model {
  static name = 'ModifierSet'

  static isConfiguration = true

  static duplicatable = true

  static paginate = true

  static deletable = true

  static versioned = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Concession]

  static define () {
    this.concerns = [Archivable, Librariable, SalesChannelRestrictable]

    this.fields = {
      id: {
        type: ID,
        required: true
      },
      modifiers: {
        type: [Modifier],
        default: () => ([]),
        reference: true
      },
      modifierIds: {
        type: [ID],
        computed () {
          if (this.modifiers) return _.map(this.modifiers.data, 'id')

          if (!this.data) return []

          return this.data.modifierIds
        },
        encode (data) {
          if (this.modifiers) {
            data.modifierIds = _.map(this.modifiers.data, 'id')
          } else {
            data.modifierIds = this.data.modifierIds
          }
        },
        default: () => ([])
      },
      name: {
        type: String,
        required: true,
        translatable: true
      },
      displayOrder: {
        type: Integer,
        default: 100
      },
      multiselect: {
        type: Boolean,
        default: true
      },
      printingOptions: {
        type: JsonObject,
        default: () => ({
          print_name: true
        })
      }
    }

    this.computed = {
      activeModifiers () {
        return _.filter(this.modifiers?.data, 'isActive')
      },
      minimumAvailableModifiers () {
        if (_.isEmpty(this.activeModifiers)) return 0

        const salesChannelCounts = _.map(this.enabledSalesChannels, channel => {
          return _.filter(this.activeModifiers, modifier => modifier.isSalesChannelEnabled(channel)).length
        })

        return _.min(salesChannelCounts) || 0
      },
      description () {
        return _.map(this.activeModifiers, 'description').join(', ')
      }
    }

    this.mutations = {
      updateModifierOrder: {
        arguments: {
          modifierSetId: {
            type: ID,
            required: true
          },
          modifierIds: {
            type: [ID],
            required: true
          }
        },
        results: {
          success: Boolean,
          errors: [GqlError]
        }
      }
    }
  }

  get salesChannelRestrictableChannelsDefault () {
    return SALES_CHANNEL_MENU_DEFAULT
  }

  get salesChannelRestrictableOptions () {
    return this.activeModifiers
  }

  async updateModifierOrder (modifierIds) {
    const results = await executeMutation(
      'updateModifierOrder',
      {
        modifierSetId: this.id,
        modifierIds
      },
      {
        success: true,
        errors: {
          structure: {
            code: true,
            description: true
          }
        }
      }
    )

    return results
  }
}
